import React from 'react';

export const camelCase = (str: string): string =>
  str.replace(/[-_]([a-z])/g, letter => letter[1].toUpperCase());

export const capitalize = (str: string): string =>
  [str.charAt(0).toUpperCase(), str.slice(1)].join('');

export const random = (length = 5): string =>
  (Math.random() + 1).toString(36).substr(2, length);

const NL_BR_REGEX = /(\r\n|\r|\n)/g;

export const nlBr = (str: string): JSX.Element => {
  const mapped = str.split(NL_BR_REGEX).map((line, index) =>
    // eslint-disable-next-line react/no-array-index-key
    line.match(NL_BR_REGEX) ? <br key={index} /> : line,
  );

  return <>{mapped}</>;
};
